<template>
  <div>
    <servico-manutencao-modal
      ref="servico-manutencao-modal"
      @remover-servicos="removerViaModal"
      @close-modal="manipulaModal('close')"
      @close-modal-add="manipulaModal($event, 'add')"
    />
    <div>
      <v-combobox
        v-model="criterio.servicoManutencao"
        :items="criterio.servicoManutencao"
        item-text="codigo"
        item-value="id"
        outlined
        readonly
        dense
        hide-details
        append-icon="pi pi-search"
        @click="abrirModal"
        @mousedown="abrirModal"
        @mouseup="abrirModal"
      />
    </div>
  </div>
</template>
    
<script>
import ServicoManutencaoModal from '@/views/modulos/cadastros/orcamentos/components/modais/ServicoManutencaoModal'

export default {
    components: {
        ServicoManutencaoModal
    },
    props:{
        criterio: {
            default: '',
            required: false,
        }
    },
    data() {
        return {
            componentKey: 0,
            conteudo: [],
            selecionados: [],
            okDesabilitado: true,
            select: [],
            servicoManutencao:[],
            items: [
                'Programming',
                'Design',
                'Vue',
                'Vuetify',
                ],
            };
    },
    computed: {
        formattedItems() {
            return this.selecionados.map((item) => item);
        },
    },
    watch:{
        'formattedItems'(itens){
            let criterios = this.$store.getters['criterios/getCriterios']

            const itemEncontrado = criterios.find(item => item.sequencia === this.criterio.sequencia);
            if(itens[0] && itemEncontrado) {
                itemEncontrado['servicoManutencao'] = {
                    codigo: itens[0].codigo,
                    id: itens[0].id
                }
                itemEncontrado['servicoManutencaoId'] = itens[0].id
                this.$store.dispatch('criterios/updateCriterio', {updatedCriterio: itemEncontrado});
            }
        }
    },
    mounted(){
        this.setup()
    },
    methods: {
        setup(){
            let criterios = this.$store.getters['criterios/getCriterios']
            const itemEncontrado = criterios.find(item => item.sequencia === this.criterio.sequencia);
            
            if (itemEncontrado && itemEncontrado.servicoManutencao && (itemEncontrado.servicoManutencao.codigo || itemEncontrado.servicoManutencao.id)) {
                this.selectedItem = {
                    codigo: itemEncontrado.servicoManutencao.codigo,
                    id: itemEncontrado.servicoManutencao.id
                }
            }
        },
        removerViaModal(itens) {
            this.$emit('remover-servicos', itens);
        },
        manipulaModal(evento = '', tipo = '') {
            this.$emit('manipula-modal', evento, tipo);
            if (tipo === 'add') {
                this.selecionados.push(...evento.selected);
            }
            if (tipo === 'close') {
                this.abrirModal()
            }
        },
        abrirModal(event) {
            event.preventDefault();
            event.stopPropagation();
            
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.$refs['servico-manutencao-modal']) {
                        this.$refs['servico-manutencao-modal'].abrirModal(this.selecionados);
                    }
                }, 100);
            });
                
        },
        fecharModal() {
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.$refs['servico-manutencao-modal']) {
                        this.$refs['servico-manutencao-modal'].fecharModal(this.selecionados);
                    }
                }, 100);
            });
                
        },
    }
};
</script>   
    